module.exports = __webpack_public_path__ + "static/Shiva_Maran-8a9b4f7de1d06314e3b63a7241c7b1cf.jpg";